export enum EGoogleMapsValidationStatus {
  Error = 'GoogleValidationError',
  Success = 'GoogleValidationSuccess'
}
